<template>
  <div>
    <v-row justify="center">
      <v-tabs background-color="transparent" color="basil" grow>
        <v-tab to="/profile/info">Your Info</v-tab>
        <v-tab to="/profile/reset-password">Reset Password</v-tab>
        <v-tab>Activities</v-tab>
        <v-tab>Badges</v-tab>
      </v-tabs>
    </v-row>
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>